<template>
  <div class="login">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
      <h3 class="title">家园中心</h3>
      <!-- <div class="text-center mb-2">
        <el-link @click="loginType='phone'" :type="loginType==='phone'?'primary':''" class="font-small mr-2">手机号登录</el-link> 
        <el-link @click="loginType='account'" :type="loginType==='account'?'primary':''" class="font-small ml-2">账号密码登录</el-link>
      </div> -->
      <div v-if="loginType==='account'">
        <el-form-item prop="account">
          <el-input v-model="loginForm.account" type="text" autocomplete='off' auto-complete="new-password" placeholder="账号">
            <i slot="prefix" class="el-icon-user-solid"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" autocomplete='off' auto-complete="new-password" placeholder="密码">
            <i slot="prefix" class="el-icon-more"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="loginForm.code" autocomplete='off' auto-complete="new-password" placeholder="验证码" style="width: 63%"></el-input>
          <div class="login-code">
            <img :src="vsCodeUrl" @click="getVsCode" class="login-code-img"/>
          </div>
        </el-form-item>
      </div>
      
      <div v-if="loginType==='phone'">
        <el-form-item prop="phone">
          <el-input v-model="loginForm.phone" type="text" auto-complete="off" placeholder="手机号">
            <i slot="prefix" class="el-icon-phone"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="code">
          <el-input v-model="loginForm.code" auto-complete="off" placeholder="验证码" style="width: 65%">
            <i slot="prefix" class="el-icon-burger"></i>
          </el-input>
          <el-button style="margin-left: 10px;width: 30%" size="medium" type="success" :disabled="smsCodeDisabled"
                     :loading="smsCodeLoading" @click.native.prevent="getSmsCode">{{ smsCode }}
          </el-button>
        </el-form-item>
      </div>
      <el-form-item style="width:100%;">
        <el-button :loading="loading" size="medium" type="primary" style="width:100%;"
                   @click.native.prevent="handleLogin">
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <div class="el-login-footer">

    </div>
  </div>
</template>
<script>
import {sendLoginSmsCode, getCodeImg} from "@/api/login";
import {encrypt} from "@/utils/jsencrypt";

export default {
  name: "login",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号为空'));
      } else {
        const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!reg.test(value)) {
          callback(new Error('手机号不正确'));
        } else {
          callback();
        }
      }
    };
    return {
      loginType: 'account',
      vsCodeUrl: "",
      timer: null,
      smsCodeDisabled: false,
      smsCodeLoading: false,
      smsCode: '获取验证码',
      loginForm: {
        phone: "",
        code: "",
        account: '',
        password: '',
      },
      loginRules: {
        // phone: [
        //   {validator: validatePhone, trigger: "blur"},
        // ],
        account: [{required: true, trigger: "change", message: "账号不能为空"}],
        password: [{required: true, trigger: "change", message: "密码不能为空"}],
        code: [{required: true, trigger: "change", message: "验证码不能为空"}]
      },
      loading: false,
      redirect: undefined
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created() {
    this.getVsCode();
  },
  methods: {
    reset() {
      this.loginForm = {
        phone: "",
        code: "",
        account: '',
        password: '',
      }
    },
    getVsCode() {
      getCodeImg().then(res => {
        this.vsCodeUrl = "data:image/gif;base64," + res.img;
        this.loginForm.uuid = res.uuid;
      });
    },
    getSmsCode() {
      if (this.loginForm.phone) {
        const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!reg.test(this.loginForm.phone)) {
          this.$message({
            type: 'warning',
            message: '手机号不正确'
          });
          return;
        }
      } else {
        this.$message({
          type: 'warning',
          message: '手机号为空'
        });
        return;
      }
      if (!this.timer) {
        this.smsCode = 60;
        this.smsCodeLoading = true;
        this.smsCodeDisabled = true;
        this.timer = setInterval(() => {
          if (this.smsCode > 0 && this.smsCode <= 60) {
            this.smsCode--;
          } else {
            this.smsCodeLoading = false;
            this.smsCodeDisabled = false;
            this.smsCode = '获取验证码';
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000)
        sendLoginSmsCode({phone: this.loginForm.phone}).then((res) => {
          if (res.code === 200) {
            this.$message({
              type: 'success',
              message: '发送成功'
            });
          }
        })
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.loginType === 'phone') {
            this.$store.dispatch("LoginBySms", this.loginForm).then(() => {
              this.$router.push({
                path: '/index'
              })
            }).catch(() => {
              this.loading = false;
              this.reset();
            });
          } else if (this.loginType === 'account') {
            this.loginForm.password = encrypt(this.loginForm.password)
            this.$store.dispatch("LoginByAccount", this.loginForm).then(() => {
              this.$router.push({
                path: '/index'
              })
            }).catch(() => {
              this.loading = false;
              this.getVsCode();
              this.reset();
            });
          }
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">

.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url("../../assets/login.png");
  background-size: cover;
}

.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}

.login-form {
  border-radius: 6px;
  background: #ffffff;
  width: 400px;
  padding: 25px 25px 5px 25px;

  .el-input {
    height: 38px;

    input {
      height: 38px;
    }
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}

.login-tip {
  font-size: 13px;
  text-align: center;
  color: #bfbfbf;
}

.login-code {
  width: 33%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }
}

.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
}

.login-code-img {
  height: 38px;
}
</style>
